export default __webpack_public_path__ + "assets/images/803398dcd0161ce7bd63b5a14f5fb6db.png";